import { Injectable } from '@angular/core';
import { ActiveCartService } from '@spartacus/cart/base/core';
import { FeatureConfigService, RoutingService } from '@spartacus/core';
import { PageLayoutHandler } from '@spartacus/storefront';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CartPageLayoutHandlerService implements PageLayoutHandler {
  constructor(
    private cartService: ActiveCartService,
    private routingService: RoutingService,
    private featureConfig?: FeatureConfigService
  ) {}

  handle(slots$: Observable<string[]>, pageTemplate?: string, section?: string) {
    if (pageTemplate === 'CartPageTemplate' && !section) {
      if (this.featureConfig && !this.featureConfig.isEnabled('saveForLater')) {
        return combineLatest([slots$, this.cartService.getActive()]).pipe(
          map(([slots, cart]) => {
            if (cart.totalItems) {
              return slots.filter((slot) => slot !== 'EmptyCartMiddleContent' && slot !== 'EmptyCartBottomContent');
            } else {
              document.querySelector('.CartPageTemplate').classList.remove('rotating');
              document.documentElement.style.overflow = 'initial';
              return slots.filter(
                (slot) =>
                  slot !== 'TopContent' &&
                  slot !== 'CenterLeftContentSlot' &&
                  slot !== 'CenterRightContentSlot' &&
                  slot !== 'BottomContentSlot'
              );
            }
          })
        );
      }
    }

    if (pageTemplate === 'ErrorPageTemplate' && !section) {
      if (this.featureConfig && !this.featureConfig.isEnabled('saveForLater')) {
        return combineLatest([slots$, this.routingService.getRouterState()]).pipe(
          map(([slots, prod]) => {
            if (
              (prod.state.context.type === 'ProductPage' || prod.state.context.type === 'ContentPage') &&
              prod.state.semanticRoute === 'product'
            ) {
              this.routingService.goByUrl('/product-not-found');
            } else {
              return slots;
            }
          })
        );
      }
    }

    return slots$;
  }
}
